export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/logs-car-icon.9efc91f0.svg","height":34,"width":77,"blurWidth":0,"blurHeight":0};